interface Props {
  name: string | null;
  imageUrl: string | null;
  bio?: string | null;
}

const FALLBACK_BIO =
  "Schreibt für creategy über politische Kommunikation, Strategie und Wahlkampf. Sie möchten ein Gespräch? Unser Team berät Sie gern persönlich.";

export function AuthorBio({ name, imageUrl, bio }: Props) {
  if (!name && !imageUrl && !bio) return null;
  const text = bio?.trim() ? bio : FALLBACK_BIO;
  return (
    <section
      aria-label="Über die Autorin / den Autor"
      className="border-t border-border bg-secondary"
    >
      <div className="mx-auto flex max-w-4xl flex-col items-start gap-6 px-6 md:px-12 section-y md:flex-row md:items-center">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={name ?? "Autor"}
            width={96}
            height={96}
            loading="lazy"
            decoding="async"
            className="h-20 w-20 rounded-full object-cover md:h-24 md:w-24"
          />
        ) : (
          <div className="h-20 w-20 rounded-full bg-background md:h-24 md:w-24" />
        )}
        <div className="flex-1">
          <p className="font-display text-xs font-extrabold uppercase tracking-wide text-primary/70">
            Über die Autorin / den Autor
          </p>
          <p className="mt-1 font-display text-2xl font-extrabold text-primary">
            {name ?? "creategy Redaktion"}
          </p>
          <p className="mt-3 max-w-xl whitespace-pre-line font-body text-sm leading-relaxed text-foreground">
            {text}
          </p>
        </div>
      </div>
    </section>
  );
}
